import { eff } from "@/core/utils/effect-ts-abbr";
import { Directive } from "vue";

type AppFastGalleryHTMLElement = HTMLElement & {
    _appFastGalleryDisposer?: () => void;
};

type AppFastGalleryOptions =
    | undefined
    | {
          images?: readonly (string | null | undefined)[];
          interval?: number; // default: 10000 (10s)
      };

const createFastGallery = (
    el: AppFastGalleryHTMLElement,
    options: AppFastGalleryOptions,
) => {
    const images = eff.fn.pipe(
        options?.images || [],
        eff.array.filterMap(eff.option.fromNullable),
    );
    const interval = options?.interval || 10000;
    const currentIndex = () => Math.ceil(Date.now() / interval) % images.length;

    const changeImage = () => {
        const src = images[currentIndex()];
        if (el instanceof Image) {
            el.src = src;
        } else {
            el.style.backgroundImage = src;
        }
    };

    changeImage();

    const intervalId = setInterval(() => {
        if (el.isConnected) {
            changeImage();
        } else {
            clearInterval(intervalId);
        }
    }, interval);

    el._appFastGalleryDisposer = () => {
        clearInterval(intervalId);
    };
};

export const appFastGalleryDirective: Directive<
    AppFastGalleryHTMLElement,
    AppFastGalleryOptions
> = {
    mounted(el, bindings) {
        createFastGallery(el, bindings.value);
    },
    unmounted(el) {
        if (el._appFastGalleryDisposer) {
            el._appFastGalleryDisposer();
        }
    },
    updated(el, bindings) {
        if (el._appFastGalleryDisposer) {
            el._appFastGalleryDisposer();
        }

        createFastGallery(el, bindings.value);
    },
};
